import * as React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

const StyledUl = styled.ul`
  list-style-type: none;
  margin: 0;
`
const StyledLink = styled(Link)`
  color: #000;
  text-decoration: none;
`

const UnderEye = () => (
  <li>
    <strong>Under-Eye Filler</strong>
    <StyledUl>
      <li>
        <StyledLink to="/problems-with-fillers-under-the-eyes">
          Problems with Fillers Under the Eyes
        </StyledLink>
      </li>
      <li>
        <StyledLink to="/reversing-restylane-under-the-eyes">
          Reversing Restylane Under the Eyes
        </StyledLink>
      </li>
      <li>
        <StyledLink to="/10-things-you-need-to-know-about-festoons">
          10 Things You Need to Know About Under Eye Filler
        </StyledLink>
      </li>
    </StyledUl>
  </li>
)

export default UnderEye
